<template>
  <section class="dashboard-section m-t-lg m-b-lg">
    <h2><i class="far fa-file-invoice"></i> Invoices</h2>

    <div class="ibox">
      <div class="ibox-content">
        <ul class="list-detail list-detail-invoice">
          <invoice-item v-for="invoice in invoices" :key="invoice.id" :invoice="invoice"></invoice-item>
          <div class="text-center text-muted" v-show="haveNoInvoices">
            <strong>No invoices found.</strong>
          </div>
        </ul>
      </div>
      <div class="ibox-footer">
        <router-link :to="{ name: 'invoices.index' }">View All Invoices</router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import { map } from 'lodash'
  import { InvoiceDecorator } from 'decorators'
  import InvoiceItem from 'components/invoices/InvoiceItem'

  export default {
    components: {
      InvoiceItem
    },

    data () {
      return {
        invoices: []
      }
    },

    created () {
      this.getInvoices({ user_id: this.$user.id, status: 'all', page_size: 7 })
        .then((response) => {
          this.invoices = map(response.data.data, invoice => new InvoiceDecorator(invoice))
        })
    },

    computed: {
      haveNoInvoices () {
        return this.invoices.length === 0
      }
    },

    methods: mapActions('invoice', ['getInvoices'])
  }
</script>



// WEBPACK FOOTER //
// InvoiceList.vue?2036902b